exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".external-data-display-failed-6Tr9KER2mwr{color:#d94a41;font-size:0.9em}\n", ""]);
// Exports
exports.locals = {
	"failed": "external-data-display-failed-6Tr9KER2mwr"
};